import actions from './actions';
import { initialWorkspaceState, WorkspaceState } from './models';

export default function workspaceReducer(state: WorkspaceState = initialWorkspaceState, action): WorkspaceState {
  switch (action.type) {
    case actions.LOAD_WORKSPACES:
      return { ...state, loading: true, error: null };
    case actions.LOAD_WORKSPACES_SUCCESS:
      return { ...state, entities: action.payload, loading: false, error: null };
    case actions.LOAD_WORKSPACES_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case actions.LOAD_WORKSPACE_BY_ID_SUCCESS:
      return { ...state, selected: action.payload };
    case actions.LOAD_WORKSPACE_BY_ID_FAILURE:
      return { ...state, error: action.payload };
    case actions.LOAD_WORKSPACE_ORGS:
      return {
        ...state,
        orgsLoading: true,
        orgsError: null,
        orgsWorkspaceId: action.payload.workspaceId,
        orgs: state.orgsWorkspaceId === action.payload.workspaceId ? state.orgs : []
      };
    case actions.LOAD_WORKSPACE_ORGS_SUCCESS:
      return state.orgsWorkspaceId === action.payload.workspaceId
        ? { ...state, orgs: action.payload.orgs, orgsLoading: false, orgsError: null }
        : state;
    case actions.LOAD_WORKSPACE_ORGS_FAILURE:
      return { ...state, orgsLoading: false, orgsError: action.payload };
    case actions.CLEAR_WORKSPACE_ORGS:
      return { ...state, orgs: [], orgsWorkspaceId: null, orgsLoading: false, orgsError: null };
    default:
      return state;
  }
}
